import {SelectBox} from "devextreme-react/select-box"
import Popup from "devextreme-react/popup"
import {Button} from "devextreme-react/button"
import React, {useState, useRef, useEffect} from 'react'
import ScrollView from "devextreme-react/scroll-view";
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {faFileLines} from "@fortawesome/free-solid-svg-icons";
import ExtFileUploader from "../file-uploader/file-uploader";

const NewdogFiles = (props) => {


    const types = props.types
    const visible = props.visible
    const maxLengthFileName = props.maxLengthFileName || 255
    const visibleSelectBox = props.visibleSelectBox || true

    const [files, setFiles] = useState([])
    const [type,setType] = useState(types && types.length > 0 ? types[0] : null)
    const extFileUploaderRef = useRef();

    useEffect(() => {
        if (visible && types && types.length > 0) {
            setType(types[0])
        }
    }, [visible, types])

    return (
        <div>
        <Popup
            hideOnOutsideClick={false}
            visible={visible}
            onHiding={()=>{props.onClose(); setFiles([]); setType(types[0])}}
            maxWidth='500px'
            maxHeight={'90%'}
            height={'auto'}
            title="Добавить документ"
            titleRender={()=>PopupTitleWithIcon(faFileLines, "Добавить документ",()=>{props.onClose(); setFiles([]); setType(types[0])})}
        >
            <ScrollView className="big-input popupWithUploader" width='100%' height='100%'>
                <div className="px-3">
            <SelectBox visible={visibleSelectBox} dataSource={types} key="id" displayExpr="nameType" value={type} onValueChanged={(e) => setType(e.value)}/>
            {/*<FileUploader labelText='Или перетащите сюда' selectButtonText='Выберите файл(ы)' multiple={true} uploadMode="useForm" value={files} onValueChanged={(e) => {setFiles(e.value)}}/>*/}
            <ExtFileUploader maxLengthFileName={maxLengthFileName} typeFileLimit={props.typeFileLimit} ref={extFileUploaderRef} value={files} setfile={(e) => {setFiles(e)}} ></ExtFileUploader>
            <Button
                className='mt-3'
                type="default"
                icon="check"
                text="Добавить к заявке"
                disabled={files.length === 0 || !type}
                onClick={() => {
                    props.onAddFiles(type,files);
                    extFileUploaderRef.current?.clearAttachFiles();
                    props.onClose();}}
            >
            </Button>
                </div>
            </ScrollView>
        </Popup>
        </div>
    )
}

export default NewdogFiles
